import { useState } from 'react';
import { compare } from '@/utils/itemInfo';
import { CasebattlesState, casebattlesStore } from '@/stores/casebattles.store';
import { modalStore } from '@/stores/modal.store';
import useUserStore from '@/stores/user.store';
import CaseCard from '@/components/CaseBattles/Create/CaseCard';
import CaseFilter from '@/components/Modals/AddCase/CaseFilter';

const AddCase = () => {
    const { user } = useUserStore((state) => state);
    const { selected, setSelected, cases } = casebattlesStore((state) => state);
    const { toggleModal, setData, data } = modalStore((state) => state);

    const [tempSelected, setTempSelected] = useState<CasebattlesState['selected']>(
        data.tempSelected || selected
    );
    const [dropdownValue, setDropdownValue] = useState<'highToLow' | 'lowToHigh'>('highToLow');
    const [searchString, setSearchString] = useState('');

    const size = Array.from(tempSelected.values()).reduce((a, b) => a + b, 0);

    const totalAmount = Array.from(tempSelected.entries()).reduce((sum, [id, count]) => {
        const c = cases.find((x) => x.id === id);
        if (!c) return sum;
        return sum + c.priceUsd * count;
    }, 0);

    const confirm = () => {
        setSelected(tempSelected);
        toggleModal();
        setData({});
    };

    const filtered = cases
        ?.filter((item) => item.name.toLowerCase().includes(searchString.toLowerCase()))
        .sort((a, b) => compare(a, b, dropdownValue));

    return (
        <div className="flex flex-col gap-3 min-h-0">
            <CaseFilter
                searchString={searchString}
                setSearchString={setSearchString}
                dropdownValue={dropdownValue}
                setDropdownValue={setDropdownValue}
            />

            <div className="fluent-scrollbar overflow-y-auto overscroll-contain pr-1.5 pt-3 [scrollbar-gutter:stable] max-h-[440px] max-md:max-h-[60vh]">
                <div className="grid gap-2.5 [grid-template-columns:repeat(auto-fill,minmax(132px,1fr))]">
                    {filtered?.map((item) => (
                        <CaseCard
                            key={item.id}
                            closeRedirect
                            selected={tempSelected}
                            setSelected={setTempSelected}
                            added={tempSelected.has(item.id)}
                            item={item}
                        />
                    ))}
                </div>
            </div>

            <div className="flex flex-wrap items-center justify-between gap-2.5 pt-3.5 border-t border-stroke">
                <span className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-fl bg-layer_2 border border-stroke text-xs text-text_3 font-medium">
                    Balance{' '}
                    <b className="text-text_main font-bold ml-1 tabular-nums">
                        ${(user.balanceUsd ?? 0).toFixed(2)}
                    </b>
                </span>
                <div className="flex flex-wrap items-center gap-2.5">
                    <span className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-fl bg-layer_2 border border-stroke text-xs text-text_3 font-medium">
                        Selected <b className="text-text_main font-bold ml-1">{size}</b>
                    </span>
                    <span
                        className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-fl tabular-nums text-sm font-bold whitespace-nowrap"
                        style={{
                            color: '#ffb13d',
                            background: 'color-mix(in srgb, #ffb13d 10%, transparent)',
                            border: '1px solid color-mix(in srgb, #ffb13d 35%, transparent)',
                        }}
                    >
                        Amount ${totalAmount.toFixed(2)}
                    </span>
                    <button
                        type="button"
                        onClick={confirm}
                        className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-fl text-[12.5px] font-bold tracking-[0.06em] uppercase bg-layer_3 border border-stroke_strong text-text_main hover:bg-white/[0.13] hover:border-white/[0.22] hover:-translate-y-px transition-all"
                    >
                        Confirm Selection
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AddCase;
